import React from 'react'
import CustomerListPage from './CustomerListPage'

const CustomerRoutes = [
  {
    path: '',
    element: <CustomerListPage />,
    children: [
      {
        breadcrumb: 'Customer Detail',
        path: 'detail/:customerId',
        element: <CustomerListPage />,
      },
    ],
  },
]

export default CustomerRoutes
